"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _debounce3 = _interopRequireDefault(require("lodash-es/debounce"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _fontIcon = _interopRequireDefault(require("../../atoms/font-icon"));

var _button = _interopRequireDefault(require("../../atoms/button"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject13() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["top: -24px"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  width: 70px;\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  line-height: 24px;\n  ", "\n  &:focus,\n  &:hover {\n    outline: none;\n  }\n  &:before {\n    content: \"\";\n    position: absolute;\n    border: 1px solid #D4D5D6;\n    left: -3%;\n    right: -3%;\n    background: ", ";\n    ", "\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  border: 1px solid #D4D5D6;\n  max-height: 0;\n  background: ", ";\n  &:after {\n    content: \"\";\n    position: absolute;\n    height: 2px;\n    width: 86px;\n    left: 50%;\n    background: ", ";\n    ", "\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["margin-", ": 20px;"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  position: ", ";\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n        border-top: 0;\n        top: 0;\n        bottom: -11%;\n        transform: perspective(30px) rotateX(-30deg);\n      "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        border-bottom: 0;\n        bottom: 0;\n        top: -11%;\n        transform: perspective(30px) rotateX(30deg);\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        bottom: -1px;\n        transform: perspective(30px) rotateX(-30deg) translateX(-50%);\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        top: -1px;\n        transform: perspective(30px) rotateX(30deg) translateX(-50%);\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        left: 0;\n        right: 0;\n        top: 0;\n        z-index: 1;\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        left: 0;\n        right: 0;\n        bottom: 0;\n        z-index: 1;\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getCollapsiblePosition = function getCollapsiblePosition(position, direction) {
  if (position === 'relative') return (0, _styledComponents.css)(_templateObject());

  switch (direction) {
    case 'top':
      return (0, _styledComponents.css)(_templateObject2());

    case 'bottom':
    default:
      return (0, _styledComponents.css)(_templateObject3());
  }
};

var getCollapsibleDirection = function getCollapsibleDirection(direction) {
  switch (direction) {
    case 'top':
      return (0, _styledComponents.css)(_templateObject4());

    case 'bottom':
    default:
      return (0, _styledComponents.css)(_templateObject5());
  }
};

var getButtonDirection = function getButtonDirection(direction) {
  switch (direction) {
    case 'top':
      return (0, _styledComponents.css)(_templateObject6());

    case 'bottom':
    default:
      return (0, _styledComponents.css)(_templateObject7());
  }
};

var StyledWrapper = _styledComponents["default"].div(_templateObject8(), function (props) {
  return (0, _styledComponents.css)(_templateObject9(), props.direction);
}, function (props) {
  return props.position;
}, function (props) {
  return getCollapsiblePosition(props.position, props.direction);
});

var CollapsibleContent = _styledComponents["default"].div(_templateObject10(), function (props) {
  return props.background;
}, function (props) {
  return props.background;
}, function (props) {
  return getCollapsibleDirection(props.direction);
});

var CollapsibleButton = (0, _styledComponents["default"])(_button["default"])(_templateObject11(), function (_ref) {
  var direction = _ref.direction;
  return direction === 'top' ? (0, _styledComponents.css)(_templateObject12()) : (0, _styledComponents.css)(_templateObject13());
}, function (props) {
  return props.background;
}, function (props) {
  return getButtonDirection(props.direction);
});

var CollapsiblePanel =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CollapsiblePanel, _React$Component);

  function CollapsiblePanel(props) {
    var _this;

    _classCallCheck(this, CollapsiblePanel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CollapsiblePanel).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getContentRef", function (element) {
      _this.contentRef = element;
    });

    _defineProperty(_assertThisInitialized(_this), "toggleHeight", function (transition) {
      var height = _this.contentRef.scrollHeight;
      _this.contentRef.style.maxHeight = "".concat(height, "px");
      _this.contentRef.style.overflow = 'hidden';

      if (transition) {
        _this.contentRef.style.transition = 'max-height 0.5s';
      }

      _this.toggleOverflow();
    });

    _defineProperty(_assertThisInitialized(_this), "debounceToggleOverFlow", function () {
      _this.contentRef.style.overflow = 'visible';
    });

    _defineProperty(_assertThisInitialized(_this), "toggleOverflow", (0, _debounce3["default"])(_this.debounceToggleOverFlow, 500));

    _defineProperty(_assertThisInitialized(_this), "toggleOpen", function () {
      _this.setState({
        isOpen: !_this.state.isOpen
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getIcon", function () {
      var isOpen = _this.state.isOpen;
      var direction = _this.props.direction;
      var icon;

      switch (direction) {
        case 'top':
          icon = isOpen ? 'icon-chevron-down' : 'icon-chevron-up';
          break;

        case 'bottom':
        default:
          icon = isOpen ? 'icon-chevron-up' : 'icon-chevron-down';
      }

      return icon;
    });

    _this.state = {
      isOpen: props.expanded
    };
    return _this;
  }

  _createClass(CollapsiblePanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.toggleHeight(false);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.toggleHeight(true);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          collapsedContent = _this$props.collapsedContent,
          children = _this$props.children,
          expandDisabled = _this$props.expandDisabled,
          background = _this$props.background,
          direction = _this$props.direction,
          position = _this$props.position;
      var isOpen = this.state.isOpen;
      return _react["default"].createElement(StyledWrapper, {
        position: position,
        direction: direction
      }, _react["default"].createElement(CollapsibleContent, {
        innerRef: this.getContentRef,
        background: background,
        direction: direction
      }, isOpen ? children : collapsedContent), _react["default"].createElement(CollapsibleButton, {
        view: "plain",
        disabled: expandDisabled,
        onClick: this.toggleOpen,
        background: background,
        direction: direction
      }, _react["default"].createElement(_fontIcon["default"], {
        style: {
          position: 'relative'
        }
      }, this.getIcon())));
    }
  }]);

  return CollapsiblePanel;
}(_react["default"].Component);

CollapsiblePanel.propTypes = {
  /** Collapsed content. */
  collapsedContent: _propTypes["default"].node,

  /** Expanded content. */
  children: _propTypes["default"].node,

  /** Expanded by default. */
  expanded: _propTypes["default"].bool,

  /** Disable expand button. */
  expandDisabled: _propTypes["default"].bool,
  background: _propTypes["default"].string,
  direction: _propTypes["default"].oneOf(['top', 'bottom']),
  position: _propTypes["default"].oneOf(['relative', 'fixed'])
};
CollapsiblePanel.defaultProps = {
  expanded: false,
  expandDisabled: false,
  background: '#FFFFFF',
  direction: 'bottom',
  position: 'relative'
};
var _default = CollapsiblePanel;
exports["default"] = _default;